import { api } from "../helpers";

const prefix = "/rules";

export const getRulesList = (param, token) => {
	return api(`${prefix}/list`, "GET", undefined, param, token);
};

export const getRuleDetail = (param, token) => {
	const { id, ...rest } = param;

	return api(`${prefix}/${id}`, "GET", undefined, rest, token);
};

export const putRule = (payload, token) => {
	return api(`${prefix}`, "PUT", payload, undefined, token);
};

export const postRule = (payload, token) => {
	return api(`${prefix}`, "POST", payload, undefined, token);
};

export const deleteRule = (payload, token) => {
	const { id, ...rest } = payload;

	return api(`${prefix}/${id}`, "DELETE", rest, undefined, token);
};
